document.addEventListener('DOMContentLoaded', () => {
  const isTouch = 'ontouchstart' in window;

  document.querySelectorAll('.carousel__drag').forEach(track => {
    // --- Arrow controls (all devices) ---------------------------------------
    // Arrow buttons live alongside the track within the same section wrapper.
    const scope = track.parentElement;
    const prev = scope && scope.querySelector('.slideshow-control--previous');
    const next = scope && scope.querySelector('.slideshow-control--next');

    if (prev || next) {
      const items = Array.from(track.children);

      const step = () => {
        if (!items.length) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return items[0].getBoundingClientRect().width + gap;
      };

      const updateArrows = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
      };

      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      let frame;
      track.addEventListener('scroll', () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateArrows);
      }, { passive: true });

      updateArrows();
    }

    // --- Drag to scroll (desktop only) --------------------------------------
    if (isTouch) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    document.addEventListener('mouseup', () => {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX);
      track.scrollLeft = scrollLeft - walk;
    });
  });
});
